import { useEffect, useState } from 'react'
import firebase from '../../firebase/compat'

const EMPTY = { questionnaires: [], fields: [], researches: [], moments: [], options: {}, matrixRows: {}, matrixColumns: {} }

/**
 * Haalt de definitie van één openbare vragenlijst op via de Cloud Function
 * `getPublicQuestionnaire`. De pagina las Questionnaires, QuestionnaireFields,
 * Research, MeasureMoments en de opties tot 2026-11-04 zelf, wat alleen kon
 * omdat iedereen die collecties mocht lezen.
 *
 * `data` is null zolang het antwoord onderweg is. Mislukt het, dan is `data`
 * leeg (alsof de vragenlijst niet bestaat) en staat de fout in `error`, zodat
 * de pagina 'niet gevonden' toont in plaats van eindeloos te laden.
 *
 * @param {{client: string, questionnaireId: string, researchId?: string, momentId?: string}} link
 * @returns {{data: import('../../StateManagment/PublicQuestionnaireContext').PublicQuestionnaireData|null, error: {code?: string, message?: string}|null}}
 */
const usePublicQuestionnaire = ({ client, questionnaireId, researchId, momentId }) => {
    const [state, setState] = useState({ data: null, error: null })

    useEffect(() => {
        setState({ data: null, error: null })
        if (!client || !questionnaireId) return undefined

        let active = true
        firebase.app().functions('europe-west1')
            .httpsCallable('getPublicQuestionnaire')({
                client, questionnaireId, researchId: researchId || '', momentId: momentId || '',
            })
            .then((result) => {
                if (active) setState({ data: { ...EMPTY, ...(result?.data || {}) }, error: null })
            })
            .catch((err) => {
                if (!active) return
                // eslint-disable-next-line no-console
                console.error('[usePublicQuestionnaire] ophalen mislukt', err)
                setState({ data: EMPTY, error: { code: err?.code, message: err?.message } })
            })

        return () => { active = false }
    }, [client, questionnaireId, researchId, momentId])

    return state
}

export default usePublicQuestionnaire
